import './login.css';
import React, { useContext, useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import {Button, Form, Modal} from 'react-bootstrap';
import { LoadingSign } from "../Utility/loading-sign";
import { fetchLogin} from '../API/apiservice';
import { ModalApiErrorMessage } from '../Utility/errorMessage';

export const Login = (props) => {
    const [credential, setCredential] = useState({email: '', password: ''});
    const [loginError, setLoginError] = useState("");
    const [cookies, setCookie] = useCookies(['user']);
    const [show, setShow] = useState(true);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [validated, setValidated] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isApiError, setIsApiError] = useState(false);

    const handleInputChange = (event) => {
        setCredential({...credential, [event.target.name]: event.target.value});
    }

    const handleSubmit = (event) => {
        setIsApiError(false);
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
        }
        else{
            const validateUser = async () => {
                setIsLoading(true);
                const data = await fetchLogin(credential);
                if(Array.isArray(data) && data[0] == 'error')
                {
                    setIsApiError(true);
                }
                else {
                  if(data.success)
                  {
                    // setCookie('customerNumber', credential.customerNumber, { path: '/', maxAge:86400});
                    setCookie('email', credential.email, { path: '/', maxAge:86400});
                    setCookie('isCorporate', data.isCorporate, { path: '/', maxAge:86400});
                    setCookie('corpName', data.corpName, { path: '/', maxAge:86400});
                    // setCookie('customers', data.customers, { path: '/', maxAge:86400});
                    setCookie('warehouse', data.site, { path: '/', maxAge:86400});

                    localStorage.setItem('storeList', JSON.stringify(data.stores));
                    localStorage.setItem('contactEmailList', JSON.stringify(data.contactEmail));
                    localStorage.setItem('customers', JSON.stringify(data.customers));

                    props.setIsLoggedIn(true);
                  }
                  else if(data.error)
                  {
                    setLoginError(data.error);
                  }
                }
                setIsLoading(false);
              };
              validateUser();
        }
        setValidated(true);
    };


    return (
        <div className="loginPage">
        <LoadingSign isLoading={isLoading} />
        <Modal className="loginModal" backdrop="static" show={show} onHide={handleClose}>
            <Modal.Header closeButton>
            <Modal.Title>Log In</Modal.Title>
            </Modal.Header>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Modal.Body>
                <ModalApiErrorMessage isApiError={isApiError}/>
                {loginError && <Form.Text className="errorMsg">*{loginError}<br/></Form.Text>}
                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control type="email" name="email" placeholder="Enter email" value={credential.email} onChange={handleInputChange} required/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Label>Password</Form.Label>
                    <Form.Control type="password" name="password" placeholder="Password" value={credential.password} onChange={handleInputChange} required/>
                </Form.Group>
                <Form.Text className="passwordResetLink"><a href='../app/passwordReset'>Forgot Password</a></Form.Text>
                {/* <Form.Text><a href='../app/signup'>Sign Up</a></Form.Text> */}
                {/* <Button variant="primary" type="submit">
                    Submit
                </Button> */}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" type="submit">
                    Login
                </Button>
            </Modal.Footer>
            </Form>
        </Modal>
            {/* <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control type="email" placeholder="Enter email" value={credential.email} onChange={handleInputChange}/>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control type="password" placeholder="Password" value={credential.password} onChange={handleInputChange}/>
            </Form.Group>
            <Button variant="primary" type="submit">
                Submit
            </Button>
            </Form> */}
        </div>
    );
};